import { Link } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import { Button } from '@/components/ui/button';
import { Home, BookOpen } from 'lucide-react';

/**
 * Real 404 page for unmatched routes. Sends a noindex meta tag so Google
 * treats it as a true "Not Found" instead of "Soft 404".
 */
export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found — ClearCommunicationApp</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <main className="min-h-[70vh] flex items-center justify-center px-6 py-16">
        <div className="text-center max-w-md">
          <p className="text-6xl font-bold text-[#00E5CC] mb-3" data-testid="not-found-code">404</p>
          <h1 className="text-2xl sm:text-3xl font-bold mb-3">Page not found</h1>
          <p className="text-muted-foreground mb-8">
            This page doesn't exist or has moved. Try one of these instead:
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild data-testid="not-found-home-btn">
              <Link to="/"><Home className="h-4 w-4 mr-2" />Go home</Link>
            </Button>
            <Button asChild variant="outline" data-testid="not-found-blog-btn">
              <Link to="/blog"><BookOpen className="h-4 w-4 mr-2" />Browse blog</Link>
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}
